<template>
    <section class="enhanced-comment">
        <CommentaryPlusEditor
            :key="editorJsKey"
            :blocks="text"
            :filter="filter"
            :isReadOnly="true"
            @completed="completed"
        />
    </section>
</template>


<script>
import CommentaryPlusSettingsDialog from "@/dashboards/widgets/commentaryplus/CommentaryPlusSettingsDialog.vue";
import CommentaryPlusEditor from "@/dashboards/widgets/commentaryplus/CommentaryPlusEditor.vue";
export default {
    name: "CommentaryPlusWidget",
    components: {CommentaryPlusEditor},
    widgetType: {
        vueSettingsDialog: CommentaryPlusSettingsDialog,
        height: 2,
        width: 2,
    },

    data() {
        return {
            editorJsKey: Math.floor(Math.random() * 10000),
        };
    },

    props: {
        model: Object,
    },

    watch: {
        attributes() {
            this.editorJsKey = Math.floor(Math.random() * 10000);
        },
    },

    methods: {
        completed(){
            this.model.generalData.set('_completed', true);
        }
    },

    computed: {
        attributes() {
            return this.model.attributes;
        },

        text() {
            return this.attributes.text;
        },

        filter() {
            return this.attributes._effectiveFilter;
        },
    },
}

</script>

<style scoped>

.enhanced-comment{
    max-height: inherit;
    height: 100%;
    overflow: auto;
}

::v-deep .ce-block__content {
    margin: 0;
    max-width: inherit;
}

</style>